module.exports = __webpack_public_path__ + "img/GABpicture2.b55d0ba3.jpg";